// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16Vms","fullView":"styles_fullView__2SCnH"};